import clone from "../../images/cloneD+.jpg"
import niver from "../../images/niver.jpg"
import lojaJogosPedro from "../../images/LojaGamesPedro.jpg"
import sorteador from "../../images/sorteador.jpg"
import tarefas from "../../images/tarefas.jpg"
import calculadora from "../../images/calculadora.jpg"
import gitProfile from "../../images/gitProfile.jpg"
import agendaContatos from "../../images/agendaContatos.jpg"
import listaTarefasReact from "../../images/listaTarefasReact.jpg"
import Eplay from "../../images/Eplay.jpg"
import listaC from "../../images/ListaC.jpg"
import uniShield from "../../images/uniShield.jpg"
import agendaReact from "../../images/lista-react-redux.jpg"
import ingles from "../../images/CertificadoCli.jpg"
import git from "../../images/CertificadoGit.jpg"
import logica from "../../images/CertificadoLogica.jpg"
import logica2 from "../../images/logica.jpg"
import Java1 from "../../images/image.png"
import Vivo from "../../images/vivo.jpeg"
import Ebac from "../../images/ebac.jpg"

import Alura_form1 from "../../images/Alura_cert/form_1.jpg"


import Alura_html_css1 from "../../images/Alura_cert/01.jpg"
import Alura_html_css2 from "../../images/Alura_cert/02.jpg"
import Alura_html_css3 from "../../images/Alura_cert/03.jpg"
import Alura_html_css4 from "../../images/Alura_cert/04.jpg"
import Alura_html_css5 from "../../images/Alura_cert/05.jpg"
import Alura_html_css6 from "../../images/Alura_cert/06.jpg"
import Alura_html_css7 from "../../images/Alura_cert/07.jpg"
import Alura_html_css8 from "../../images/Alura_cert/08.jpg"

export const CertificadosList = [
    {
        imagem: Alura_form1,
        title: 'Formação A partir do zero: HTML e CSS para projetos web',
        resume: '350 de 350 atividades realizadas com 6 cursos concluídos durante a formação'
    },
    {
        imagem: Alura_html_css7,
        title: 'Certificado de introdução e prática de display grid no CSS',
        resume: 'Primeiros passos, Avançando no Grid, Grid layout responsivo, Criando Grid com barra de rolagem, Layout flexível unindo Grid e Flex'
    },
    {
        imagem: Alura_html_css8,
        title: 'Certificado de introdução e prática de CSS em Flexbox e layouts responsivos',
        resume: 'Conhecendo o poder do Flexbox, Rodapé responsivo, Menu mobile-first, Menu flexível, Vídeos flex-grow'
    },
    
    {
        imagem: Alura_html_css2,
        title: 'Certificado de introdução aos conceitos de ambientes de desenvolvimento, estrutura de arquivos e tags',
        resume: 'O editor de código VSCode, Documentação e HTML, Layout e tags semânticas, Estilizando o projeto com CSS, Super estilizando o seu CSS'  
    },
    {
        imagem: Alura_html_css3,
        title: 'Certificado de introdução aos conceitos de cabeçalho, footer e variáveis CSS',
        resume: 'Preparando o layout do projeto, Criando ícones clicáveis, Criando header e footer, Navegando entre páginas, Aplicando variáveis CSS'  
    },
    {
        imagem: Alura_html_css4,
        title: 'Certificado de introdução aos conceitos de classes, posicionamento e flexbox',
        resume: 'Seletores e posicionamento, Posicionando mais elementos, Estilos de texto e fontes, Manipulando botões, Ajustando o espaçamento'  
    },
    {
        imagem: Alura_html_css5,
        title: 'Certificado de prática de HTML e CSS',
        resume: 'Iniciando o projeto, A dupla HTML e CSS, Posicionando elementos, Finalizando a página, Compartilhando o projeto'  
    },
    {
        imagem: Alura_html_css1,
        title: 'Certificado de responsividade com mobile first',
        resume: 'Aplicando a metodologia mobile-first Header, Flexbox e @import, Integrando o Carrossel com SwiperJS, Selecionando Media Queries, Produzindo CSS no desktop'
    },
    {
        imagem: Alura_html_css6,
        title: 'Certificado de responsividade com HTML e CSS',
        resume: 'O editor de código VSCode, Documentação e HTML, Layout e tags semânticas, Estilizando o projeto com CSS, Super estilizando o seu CSS'  
    },  
    {
        imagem: Ebac,
        title: 'Certificado Desenvolvedor Fullstack Java/React',
        resume: 'CERTIFICADO DE MATRÍCULA',
    },
    {
        imagem: Vivo,
        title: 'Certificado Python Backend Developer',
        resume: 'Certificado do bootcamp de Python da parceria Dio e Vivo',
    },
    {
        imagem: git,
        title: 'Certificado de versionamento Git e GitHub',
        resume: 'Certificado do bootcamp da parceria Dio e Santander',
    },
    {
        imagem: ingles,
        title: 'Curso de inglês do básico ao avançado - Cli! Centro de línguas',
        resume: 'Curso de inglês do básico ao avançado onde pude fazer vários projetos, redações, provas discursivas e de conversação, foram 4 anos onde aprendi muito sobre a língua inglesa e como usá-la',
    },
    {
        imagem: logica,
        title: 'Curso de lógica de programação - Udemy',
        resume: 'Pequeno curso onde aprendi a usar lógica de programação para resolver testes, muitos deles estão no meu repositório de lógica de programação, nele aprendi o básico de várias linguagens como Python, C, Java, Javascript, portugol e mais',
    }
]

export const accordion = [
    {
        title: 'Ilusões da carreira de T.I',
        resume: 'Aqui escrevi um pouco sobre as ilusões que eu tinha do mundo da T.I',
        link: 'https://ilusoes-ti.vercel.app'
    },
    {
        title: 'Faculdade é importante para uma carreira de TI?',
        resume: 'Minha opinião sobre esse antigo debate',
        link: 'https://www.linkedin.com/posts/pedrosantos004_ti-programaaexaeto-tecnologia-activity-7172653861327900672-3TOU?utm_source=share&utm_medium=member_desktop'
    },
]

export const FrontProjects = [
    {
        imagem: Eplay,
        title: 'Eplay',
        resume: 'Loja de games ficticia completa com React e suas ferramentas',
        link: 'https://eplay-zeta.vercel.app',
        post: 'https://www.linkedin.com/posts/pedrosantos004_%C3%A9-com-imenso-prazer-e-satisfa%C3%A7%C3%A3o-que-compartilho-activity-7185757468726054912-ZYEW?utm_source=share&utm_medium=member_desktop',
        gitHub: 'https://github.com/PedroHenrique004/eplay'
    },
    {
        imagem: listaTarefasReact,
        title: 'Lista de tarefas React',
        resume: 'Lista de tarefas dinâmica usando o React e outras ferramentas como o Redux',
        link: 'https://minhas-tarefas-sable.vercel.app',
        gitHub: 'https://github.com/PedroHenrique004/minhas-tarefas'
    },
    {
        imagem: agendaReact,
        title: 'Lista de contatos com Redux',
        resume: 'Lista de contatos dinâmica usando o React e o Redux para edição, remoção e adição',
        link: 'https://lista-telefonica-react-chi.vercel.app',
        gitHub: 'https://vercel.com/pedrohenrique004s-projects/lista-telefonica-react'
    },
    {
        imagem: agendaContatos,
        title: 'Agenda de contatos',
        resume: 'Agenda de contatos usando apenas o javascript',
        link: 'https://projeto-2-agenda-de-contatos-seven.vercel.app',
        gitHub: 'https://github.com/PedroHenrique004/Projeto-2-Agenda_de_contatos'
    },
    {
        imagem: gitProfile,
        title: 'Git Profile',
        resume: 'Projeto usando a API do GitHub buscando os repositórios do usúario pesquisado',
        link: 'https://github-perfil-nine-pied.vercel.app',
        gitHub: 'https://vercel.com/pedrohenrique004s-projects/github-perfil'
    },
    {
        imagem: calculadora,
        title: 'Calculadora Aritmética',
        resume: 'Uma calculado criada com Vue.js',
        link: 'https://calculadora-aritmetica-kappa.vercel.app',
        gitHub: 'https://github.com/PedroHenrique004/calculadora-aritmetica'
    },
    {
        imagem: tarefas,
        title: 'Lista de tarefas Vue',
        resume: 'Lista de tarefas dinâmica criada com Vue.js e bootstrap',
        link: 'https://todo-vue-ashen-six.vercel.app',
        gitHub: 'https://github.com/PedroHenrique004/todo-vue'
    },
    {
        imagem: sorteador,
        title: 'Sorteador',
        resume: 'Pequeno sorteador onde aprendi a usar as funções Math do Javscript',
        link: 'https://sorteador-grunt-pedro.vercel.app',
        gitHub: 'https://github.com/PedroHenrique004/sorteador_grunt'
    },
    {
        imagem: clone,
        title: 'Clone Disney+',
        resume: 'Clone do site do Disney Plus onde revisei muito bem os conceitos de CSS e Javascript',
        link: 'https://clone-disney-plus-tan.vercel.app',
        gitHub: 'https://github.com/PedroHenrique004/clone_Disney_Plus'
    }, 
    {
        imagem: lojaJogosPedro,
        title: 'Loja de jogos do Pedro',
        resume: 'Pequeno site onde construi o layout utilizando o Bootstrap e várias funções do javascript',
        link: 'https://loja-de-jogos-eight.vercel.app',
        gitHub: 'https://github.com/PedroHenrique004/Loja_de-jogos'
    },
    {
        imagem: niver,
        title: 'Página de aniversário',
        resume: 'Site onde usei as funções de tempo do Javascript para fazer uma contagem regressiva',
        link: 'https://meu-aniversario-gamma.vercel.app',
        gitHub: 'https://github.com/PedroHenrique004/Meu-aniversario'
    }
]

export const BackProjects = [
    {
        imagem: Java1,
        title: 'Cadastro de clientes com Java',
        resume: 'Projeto 1 do curso de Back-end com Java na EBAC',
        link: 'https://github.com/PedroHenrique004/Java-Projects/tree/master/src/P1_Cadastro_de_Clientes',
        post: 'https://www.linkedin.com/posts/pedrosantos004_java-programacao-ti-activity-7174225041964843010-e2pi?utm_source=share&utm_medium=member_desktop'
    },
    {
        imagem: listaC,
        title: 'Lista de tarefas em C',
        resume: 'Projeto final da matéria de algoritmos e lógica de programação',
        link: 'https://github.com/PedroHenrique004/Projeto_Final_De_Algoritmos'
    },
    {
        imagem: logica2,
        title: 'Lista de problemas que resolvi para treinar a lógica',
        resume: 'Repositório onde guardei os problemas que resolvi no curso livre da Udemy',
        link: 'https://github.com/PedroHenrique004/Logica_De_Programacao'
    }
]

export const ExtraProjects = [
    {
        imagem: uniShield,
        title: 'Protótipo do aplicativo UniShield',
        resume: 'Projeto final da matéria de Engenharia de Software onde criamos um protótipo de um aplicativo que reforçaria a segurança nas faculdades, projeto o quel me deu diversas habilidades e noções de como é o mundo real na programação.',
        link: 'https://www.figma.com/proto/C1ixxq8o55q2p9JlJRRapT/Prototipação---TESTE?node-id=284-685&starting-point-node-id=284%3A685'
    }
]